import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { TextField, Grid } from '@mui/material'
import { useWalletsFilters } from '@/views/wallets/hooks/use-wallets-filters.hook'
import { WalletStatusBonusFilter, WalletTypeBonusFilter } from './'

export const WalletsFilters = () => {
  const { t } = useTranslation()

  const { filters, handleChangeSearch } = useWalletsFilters()

  const location = useLocation()

  const isPlayerCard = location.pathname.includes('/player-card')

  return (
    <Grid container spacing={1} alignItems="flex-end">
      <Grid item xs={12} md={4} lg={2}>
        <WalletStatusBonusFilter
          filters={filters}
          handleChangeSearch={handleChangeSearch}
        />
      </Grid>
      {!isPlayerCard && (
        <>
          <Grid item xs={12} md={4} lg={2}>
            <TextField
              autoComplete="off"
              fullWidth
              name="playerId"
              label={t('labels.playerId')}
              margin="dense"
              variant="outlined"
              value={filters?.playerId || ''}
              onChange={(e: React.ChangeEvent<{ value: string }>) => {
                handleChangeSearch({ playerId: e.target.value }, true)
              }}
              InputProps={{
                inputProps: {
                  maxLength: 100,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={2}>
            <TextField
              autoComplete="off"
              fullWidth
              name="username"
              label={t('labels.username')}
              margin="dense"
              variant="outlined"
              value={filters?.username || ''}
              onChange={(e: React.ChangeEvent<{ value: string }>) => {
                handleChangeSearch({ username: e.target.value }, true)
              }}
              InputProps={{
                inputProps: {
                  maxLength: 100,
                },
              }}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12} md={4} lg={2}>
        <TextField
          autoComplete="off"
          fullWidth
          name="bonusCode"
          margin="dense"
          variant="outlined"
          label={t('labels.bonusCode')}
          value={filters?.bonusCode || ''}
          onChange={(e: React.ChangeEvent<{ value: string }>) => {
            handleChangeSearch({ bonusCode: e.target.value }, true)
          }}
          InputProps={{
            inputProps: {
              maxLength: 100,
            },
          }}
        />
      </Grid>
      <Grid item xs={12} md={4} lg={2}>
        <WalletTypeBonusFilter
          filters={filters}
          handleChangeSearch={handleChangeSearch}
        />
      </Grid>
    </Grid>
  )
}
